import React from 'react'

const BulletinHeader = ({
  text1 = '',
  text2 = '',
  text3 = '',
  bgColor1 = '#0341F0',
  bgColor2 = '#266EF0',
  bgColor3 = '#F9AF2E',
  fontColor = 'white',
}) => {
  return (
    <div
      style={{
        color: fontColor,
        background: bgColor1,
      }}
      className="w-full flex justify-center items-center h-[23px] prayer-time-scroll-text"
    >
      <div className="flex xl:justify-between items-center text-xs xl:text-[13px] 2xl:text-[15px] w-full h-full">
        <div
          style={{ background: bgColor1 }}
          className="h-full flex justify-center items-center xl:w-[22.76%] font-semibold px-2 xl:px-0"
        >
          <p className="mb-0">{text1}</p>
        </div>
        <div
          style={{
            background: `linear-gradient(to bottom right, ${bgColor1} 50%, ${bgColor2} 50%)`,
          }}
          className="aspect-square h-full"
        />
        <div
          style={{ background: bgColor2 }}
          className="flex items-center justify-center font-semibold xl:w-[21.669%] h-full  px-2 xl:px-0"
        >
          <p className="mb-0">{text2}</p>
        </div>
        <div
          style={{
            background: `linear-gradient(to bottom right, ${bgColor2} 50%, ${bgColor3} 50%)`,
          }}
          className="aspect-square h-full "
        />
        <div
          style={{ background: bgColor3 }}
          className="h-full w-fu xl:w-[54.099%] flex justify-center items-center  px-2 xl:px-0"
        >
          <div className="flex items-center">
            <p className="font-bold mb-0">{text3}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BulletinHeader
